export const compareSearch = (name, value) => name.toLowerCase().includes(value.toLowerCase());

const filterData = (items, searchValue) => items.filter((item) => (
  item.name
    ? compareSearch(item.name, searchValue)
    : false
));

export default filterData;
